import { render, staticRenderFns } from "./DraftSaveButton.vue?vue&type=template&id=121db281&scoped=true&"
import script from "./DraftSaveButton.vue?vue&type=script&lang=js&"
export * from "./DraftSaveButton.vue?vue&type=script&lang=js&"
import style0 from "./DraftSaveButton.vue?vue&type=style&index=0&id=121db281&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121db281",
  null
  
)

export default component.exports